module.exports = __webpack_public_path__ + "static/media/A113.88a73567.jpg";